import qualityEvents from '../../services/quality-events';
import cookies from '../../utils/browser-storage/cookies';
import { DISPLAY_CODES, STORAGE_KEY, TIMER_COOKIE_NAME } from './new-worlds-launch-modal.constants';

export const shouldNeverBeShownAgain = () => Number(window.storage.getItem(STORAGE_KEY)) === DISPLAY_CODES.NEVER_AGAIN;

export const is7DayTimerSet = () => cookies.getItem(TIMER_COOKIE_NAME);

export const wasShown7DaysAgo = () =>
    Number(window.storage.getItem(STORAGE_KEY)) === DISPLAY_CODES.SHOW_AGAIN_IN_7_DAYS;

export const trackPopupInteraction = (extra: string) =>
    extra && qualityEvents.track({ extra, type: 'newWorldsPromotionPopupInteraction' });
